import resolvePromise from '../helper/resolved_promise';
import ActiveProductActions from '../constants/active_product/actions';
import Dispatcher from '../dispatcher';

function setActiveProductAction(product) {
    Dispatcher.handleActiveProductAction({
        type: ActiveProductActions.SET_ACTIVE_PRODUCT,
        payload: product
    });

    return resolvePromise();
}

function unsetActiveProductAction() {
    Dispatcher.handleActiveProductAction({
        type: ActiveProductActions.UNSET_ACTIVE_PRODUCT
    });

    return resolvePromise();
}

export {
    setActiveProductAction,
    unsetActiveProductAction,
};
